<template>
    <div>
        <p class="adresse" v-if=entreprise.acf.adresse>{{ entreprise.acf.adresse }}, 67205 Oberhausbergen</p>
        <a class="telephone" v-if=entreprise.acf.telephone :href="'tel:'+entreprise.acf.telephone.replace(/ /g,'')" target="_blank">{{ entreprise.acf.telephone }}</a>
        <a class="site" v-if=entreprise.acf.site_internet :href="entreprise.acf.site_internet" target="_blank">Voir le site internet</a>
        <p class="horaires" v-if=entreprise.acf.horaires_ouverture>{{ entreprise.acf.horaires_ouverture }}</p>
    </div>
</template>

<script>
export default {
    props: {
        entreprise: Object,
    },
    data() {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
div {
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
    p,
    a,
    dt,
    dd {
        color: var(--black);
        font-size: 14px;
        font-weight: 400;
    }
    a:hover {
        color: var(--green);
    }
    p,
    a,
    dt {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        &::before {
            content: "";
            width: 15px;
            height: 15px;
            margin: 0;
            margin-right: 10px;
            padding: 0;
            display: inline-block;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
        }
    }
    .adresse {
        &::before {
            background-image: url("../../assets/images/icons/icon-location.svg");
        }
    }
    .telephone {
        text-decoration: none;
        &::before {
            background-image: url("../../assets/images/icons/icon-phone.svg");
        }
    }
    .site {
        color: var(--green);
        &::before {
            background-image: url("../../assets/images/icons/icon-website.svg");
        }
        // &::after {
        //     content: "";
        //     width: 15px;
        //     height: 15px;
        //     margin: 0;
        //     margin-left: 10px;
        //     padding: 0;
        //     display: inline-block;
        //     background-image: url("https://interval-strasbourg.eu.dev.esilab.fr/site/wp-content/uploads/2023/01/link-arrow.svg");
        //     background-size: contain;
        //     background-repeat: no-repeat;
        //     background-position: center center;
        // }
    }
    .horaires {
        &::before {
            background-image: url("../../assets/images/icons/icon-clock.svg");
        }
    }
}
</style>